import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseSection from '../BaseSection';
import {
  ContactPhoneBox,
  ContactMailBox,
  ContactWebsiteBox,
  ContactScheduleBox,
  ContactBrochureBox
} from '../../ContactBox';

const OwnerSection = memo(
  ({
    ownerName,
    clickHandler,
    phonesShown,
    phonesMasked = [],
    contactEmail,
    website,
    schedule,
    brochureUrl,
    imageUrl
  }) => {
    const { t } = useTranslation();

    return (
      <BaseSection>
        <div className="owner__container">
          <div className="owner">
            <div className="owner__data">
              {ownerName && <div className="owner__name">{ownerName}</div>}
              <div className="owner__type">{t('residences.name')}</div>
            </div>
            {imageUrl && (
              <img
                src={imageUrl}
                className="owner__img"
                alt={t('residences.logo', { name: ownerName })}
              />
            )}
          </div>

          {phonesMasked.map((phone, i) => (
            <ContactPhoneBox
              key={i}
              value={phonesShown?.length ? phonesShown[i] : phone}
              boxText={t('common.call')}
              onClickHandler={phonesShown ? null : clickHandler(i, false)}
            />
          ))}
          {contactEmail && contactEmail?.length > 0 && (
            <ContactMailBox value={contactEmail} />
          )}
          {website && website.trim()?.length > 1 && (
            <ContactWebsiteBox value={website} />
          )}
          {schedule && schedule?.length > 0 && (
            <ContactScheduleBox value={schedule} />
          )}
          {brochureUrl && brochureUrl?.length > 0 && (
            <ContactBrochureBox value={brochureUrl} />
          )}
        </div>
      </BaseSection>
    );
  }
);

OwnerSection.displayName = `OwnerSection`;

OwnerSection.propTypes = {
  ownerName: PropTypes.string,
  ownerType: PropTypes.string,
  clickHandler: PropTypes.func,
  phonesShown: PropTypes.array,
  phonesMasked: PropTypes.array,
  contactEmail: PropTypes.string,
  website: PropTypes.string,
  schedule: PropTypes.string,
  brochureUrl: PropTypes.string,
  imageUrl: PropTypes.string
};

export default OwnerSection;
